// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"149aabab","239":"e229cffe","455":"6dd9034e"}[chunkId] + ".chunk.js";
};